import React from 'react';
export var LoadingOverlay = function () { return (React.createElement("div", { className: "loading-overlay" },
    React.createElement("div", { className: "loading-overlay--inner" }))); };
//# sourceMappingURL=LoadingOverlay.js.map